import React from 'react';
import PropTypes from 'prop-types';
import Panel from '@prisjakt/ui-panel';

import {
  Banner,
  BadgeSection,
  BadgeImage,
  MainSection,
  Description,
  Button,
} from './styles';

const CampaignBanner = ({
  url,
  imageUrl,
  badgeUrl,
  badgeAltText,
  description,
  linkText,
}) => (
  <Panel margin="bottom">
    <Banner style={{ backgroundImage: `url(${imageUrl})` }}>
      {badgeUrl && (
        <BadgeSection>
          <BadgeImage src={badgeUrl} alt={badgeAltText} />
        </BadgeSection>
      )}
      <MainSection>
        <Description>{description}</Description>
        <Button to={url}>{linkText}</Button>
      </MainSection>
    </Banner>
  </Panel>
);

const { string } = PropTypes;

CampaignBanner.propTypes = {
  url: string,
  imageUrl: string,
  badgeUrl: string,
  badgeAltText: string,
  description: string,
  linkText: string,
};

CampaignBanner.defaultProps = {
  url: undefined,
  imageUrl: undefined,
  badgeUrl: undefined,
  badgeAltText: undefined,
  description: undefined,
  linkText: undefined,
};

export default CampaignBanner;
